module.exports = __webpack_public_path__ + "img/icon-evaluation.a4068455.svg";